module.exports = __webpack_public_path__ + "2b3863eee14e8cee301f39723f64270c.MP3";